import React, {useEffect, useState} from "react";
import {ConfigProvider} from "tea-component";
import PerformanceMetricsTable from "@/pages/dashboard/components/PerformanceMetricsTable";
import {SortBy} from 'tea-component/es/table/addons/sortable';
import {REPORT_PARAMS} from "@/pages/dashboard/pages/datalab/ReportAnalysis/types";
import {getDatalabAnalysisDashboard} from "@/pages/dashboard/services/datalab";
import {numFormat} from "@/pages/dashboard/utils/utils";


function ReportTable(props) {
	const {
		dashboardUuid,
		queries,
		sortChange,
		data,
		count,
		columnName,
		loading: tableLoading,
		error: tableError,
		isEn,
		getDynamicLocalText
	} = props;


	const [records, setRecords] = useState([]);
	const [sort, setSort] = useState<SortBy>({});
	// 分页信息
	const [pageInfo, setPageInfo] = useState<any>({pageSize: 10, pageIndex: 1});

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(tableError);
	const [columns, setColumns] = useState([]);
	const [sortColumns, setSortColumns] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [total, setTotal] = useState(0);
	useEffect(() => {
		setTableData(data || []);
		setRecords(data?.slice(0, 10) || []);
		const columns = [];
		const sortColumns = [];
		columnName?.forEach(item => {
			columns.push({
				key: item.name,
				header: isEn ? (item.name_en || item.name) : item.name,
				render(record) {
					const data = record[item.name] || "-";
					return isNaN(data) ? getDynamicLocalText(item.name?.split("_")?.[1] || item?.name, data, isEn) : numFormat(data);
				}
			});
			if (item.can_sort) {
				sortColumns.push({
					key: item.name,
					prefer: 'desc',
				});
			}
		});
		setColumns(columns);
		setSortColumns(sortColumns);
		setTotal(count);
	}, [data, count, columnName, isEn]);


	const requestSortTableData = (params: REPORT_PARAMS) => {
		setLoading(true);
		setTableData([]);
		setRecords([]);
		setError(undefined);
		getDatalabAnalysisDashboard(params).then((response) => {
			const {count, table_data = []} = response ?? {};
			const {pageIndex = 1, pageSize = 10} = pageInfo ?? {};
			const start = (pageIndex - 1) * pageSize;
			const end = pageIndex * pageSize;
			setRecords(table_data?.slice(start, end));
			setTableData(table_data);
			setTotal(count);
			setLoading(false);
		}).catch(e => {
			console.log("请求表格接口错误: ", e);
			setError(e);
			setLoading(false);
		});
	};
	return (
		<ConfigProvider locale={isEn ? "en" : "zh"}>
			<PerformanceMetricsTable
				columns={columns}
				records={records}
				copyConfig={
					{
						copyData:records
					}
				}
				bordered="all"
				loading={tableLoading || loading}
				isError={!!error}
				showDownloadBtn={false}
				paging={{
					pageSize: pageInfo.pageSize,
					pageIndex: pageInfo.pageIndex,
					recordCount: total > 2000 ? 2000 : total,
					stateText: isEn ? `${total} records ${total > 2000 ? 'Exceeding the front-end display limit, please download the data and perform statistics' : ''}` : `共 ${total} 项 ${total > 2000 ? '超过前端可展示上限,请下载数据后进行统计' : ''}`,
					onPagingChange: (query: any) => {
						setPageInfo(query);
						// 前端分页 计算当前页表格数据
						const {pageIndex = 1, pageSize = 10} = query ?? {};
						const start = (pageIndex - 1) * pageSize;
						const end = pageIndex * pageSize;
						setRecords(tableData.slice(start, end));
					},
				}}
				sorting={{
					config: {value: [sort]},
					onSortChange: (value: SortBy[]) => {
						const sort = value[0] || {};
						setSort(sort);
						sortChange(value[0] ? {label: value[0].by, sort_model: value[0].order} : null);
						const orderby = [];
						if (Object.keys(sort)?.length > 0) orderby.push({
							label: sort.by,
							sort_model: sort.order,
						});
						const params = {
							dashboard_uuid: dashboardUuid,
							page: 1,
							pagesize: 2000,
							queries: {
								...queries,
								orderby
							}
						};
						requestSortTableData(params);
					},
				}}
			/>
		</ConfigProvider>);
}

export default ReportTable;
